angular
    .module('empower.control')
    .directive("clickOutside", ['$rootScope', function ($rootScope) {
        return {
            restrict: 'A',
            scope: {
                clickOutside: '&'
            },
            link: function (scope, elem, attr) {
                var classList = (attr.outsideIfNot !== undefined) ? attr.outsideIfNot.replace(', ', ',').split(',') : [];
                if (attr.id !== undefined) classList.push(attr.id);
                var counter = 0;
                //console.log("popup vis "+$(".popup").is(":visible"));

                $(".popup").on('click', function (e) {
                    //console.log(attr.clickOutside);
                    var i = 0,
                        element;

                    if (!e.target) return;

                    for (element = e.target; element; element = element.parentNode) {
                        var id = element.id;
                        var classNames = element.className;

                        if (id !== undefined) {
                            for (i = 0; i < classList.length; i++) {
                                if (id.indexOf(classList[i]) > -1 || classNames.indexOf(classList[i]) > -1) {
                                    //console.log(id, classList, id.indexOf(classList[i]), classNames.indexOf(classList[i]) );
                                    //console.log(scope.clickOutside);
                                    return;
                                } else {
                                    counter++;
                                }
                            }
                        }
                    }

                    //alert( action );
                    $rootScope.$apply(function () {
                        $rootScope.clickOutsideClicked === false ? scope.$eval(scope.clickOutside) : "";
                        //console.log("counter "+counter);
                    });
                    e.stopPropagation();
                    e.preventDefault();
                    //scope.$eval( attr.clickOutside );
                });
            }
        };

    }]);
